const infoItems = [
  { icon: 'ri-map-pin-line', label: 'LOKACIJA', value: 'Cvetkovci 50, Podgorci' },
  { icon: 'ri-home-heart-line', label: 'AMBIENT', value: 'Domače, družinsko vzdušje' },
  { icon: 'ri-restaurant-2-line', label: 'DOŽIVETJE', value: 'Domača kuhinja • Tradicija' },
  {
    icon: 'ri-time-line',
    label: 'DELOVNI ČAS',
    value: 'Pon–Čet 06:30 – 23:00\nPet–Sob 06:30 – 01:00\nNed zaprto',
  },
];

export default function QuickInfoSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative z-20 bg-background-950 -mt-1">
      <div className="w-full px-5 md:px-10 lg:px-14 py-8 md:py-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {infoItems.map((item, idx) => (
              <div
                key={idx}
                onClick={() => scrollTo('kontakt')}
                className="quick-info-item group flex items-start gap-3 md:gap-4 p-3 md:p-4 rounded-lg hover:bg-white/[0.04] transition-all duration-300 cursor-pointer"
              >
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 flex-shrink-0 transition-colors duration-300">
                  <i className={`${item.icon} text-primary-400 text-base md:text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <p className="font-label text-[10px] md:text-xs tracking-extra-wide text-primary-400 font-medium mb-0.5 md:mb-1">
                    {item.label}
                  </p>
                  <p className="font-body text-xs md:text-sm text-foreground-100/80 group-hover:text-foreground-50 transition-colors duration-300 whitespace-pre-line">
                    {item.value}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}